import React, {useState} from "react";
import JoinTeam from "assets/images/joinTheTeam.png";
import Button from "components/shared/Button";
import JoinTeamModal from "./JoinTeamModal";

const JoinOurTeam = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal=() => {
    setShowModal(!showModal)
  }
  return (
    <>
    <div className="mt-7 bg-white 2xl:m-auto 2xl:max-w-[1234px] px-4 md:px-12 w-full py-16 flex items-center justify-center ">
      <div className="md:w-[1234px] w-full bg-blueShades-7 rounded-xl">
        <div className="flex md:flex-row flex-col md:justify-between justify-center items-center md:py-5 md:pr-5 md:pl-10 px-2 py-3 gap-5 md:gap-0">
          <div className="flex flex-col gap-5 items-center justify-center md:items-start md:justify-start">
            <h1 className="text-bblack-5 font-bold text-5xl text-center md:text-left">Join our team</h1>
            <p className="text-lg text-bblack-5 font-Medium lg:w-[41.9ch] md:w-[26ch] w-[97%]">
              We are always looking to connect with missional professionals to
              fill open roles. Leave us some details and we will reach out with
              roles that fit you.{" "}
            </p>
            <Button
              label="See job openings"
              className=" !bg-bblack-5 !w-[164px] !py-[10px] !px-[18px] !text-sm"
              onClick={toggleModal}
            />
          </div>
          <div className="">
            <img
              alt="A man operating a laptop"
              src={JoinTeam}
              className="lg:w-[477px] w-[366px] sm:w-full"
            />
          </div>
        </div>
      </div>
    </div>
    {showModal && <JoinTeamModal closer={() => setShowModal(false)}/>}
    </>
  );
};
export default JoinOurTeam;
